var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldcheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2846_5149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.8C0 1.32261 0.189642 0.864773 0.527208 0.527208C0.864773 0.189642 1.32261 0 1.8 0L10.2 0C10.6774 0 11.1352 0.189642 11.4728 0.527208C11.8104 0.864773 12 1.32261 12 1.8V3.9084C11.9998 5.69172 11.4386 7.42978 10.3958 8.87641C9.35295 10.323 7.88142 11.4049 6.1896 11.9688C6.06652 12.0098 5.93348 12.0098 5.8104 11.9688C4.11858 11.4049 2.64705 10.323 1.60423 8.87641C0.561418 7.42978 0.000175296 5.69172 0 3.9084L0 1.8ZM8.85 3.9C8.90909 3.82121 8.95209 3.73155 8.97654 3.63614C9.00098 3.54073 9.00639 3.44144 8.99246 3.34393C8.97853 3.24643 8.94554 3.15263 8.89536 3.06788C8.84518 2.98313 8.77879 2.9091 8.7 2.85C8.62121 2.79091 8.53155 2.74791 8.43614 2.72346C8.34073 2.69902 8.24144 2.69361 8.14393 2.70754C8.04643 2.72147 7.95263 2.75446 7.86788 2.80464C7.78313 2.85483 7.7091 2.92121 7.65 3L5.4 6L4.2 5.1C4.12121 5.04091 4.03155 4.99791 3.93614 4.97346C3.84073 4.94902 3.74144 4.94361 3.64393 4.95754C3.54643 4.97147 3.45263 5.00446 3.36788 5.05464C3.28313 5.10483 3.2091 5.17121 3.15 5.25C3.09091 5.32879 3.04791 5.41845 3.02346 5.51386C2.99902 5.60927 2.99361 5.70856 3.00754 5.80607C3.02147 5.90357 3.05446 5.99737 3.10464 6.08212C3.15482 6.16687 3.22121 6.24091 3.3 6.3L5.1 7.65C5.17879 7.7091 5.26845 7.75209 5.36386 7.77654C5.45927 7.80098 5.55856 7.80639 5.65607 7.79246C5.75357 7.77853 5.84737 7.74554 5.93212 7.69536C6.01687 7.64518 6.09091 7.57879 6.15 7.5L8.85 3.9Z",
    fill: "#F58220"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2846_5149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldcheckIcon);
export default __webpack_public_path__ + "static/media/shield check_icon.c9f0b229c6764d12ee010f059afc9754.svg";
export { ForwardRef as ReactComponent };